function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    cms-video\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.44,35.68H6.56a5.43,5.43,0,0,1-5.42-5.42V9.75A5.43,5.43,0,0,1,6.56,4.32H33.44a5.44,5.44,0,0,1,5.43,5.43V30.26A5.44,5.44,0,0,1,33.44,35.68ZM6.56,6.57A3.18,3.18,0,0,0,3.39,9.75V30.26a3.18,3.18,0,0,0,3.17,3.17H33.44a3.19,3.19,0,0,0,3.18-3.17V9.75a3.19,3.19,0,0,0-3.18-3.18Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.06,26.77a2.21,2.21,0,0,1-.87-.17,2.28,2.28,0,0,1-1.4-2.1v-9a2.27,2.27,0,0,1,3.75-1.73l8,4.61a2.27,2.27,0,0,1,0,3.22l-.23.18-7.74,4.43A2.24,2.24,0,0,1,17.06,26.77Zm0-11.28,0,9,.1-.11.18-.06L24.87,20Zm8.64,5.32h0Z",
  fill: "#231f20"
});

function SvgCmsVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3);
}

export default SvgCmsVideo;